import Footer from "components/Footer/Footer";
import Navbar from "components/Navbar/Navbar";
import ScrollUp from "components/ScrollUp/ScrollUp";
import { useScrollAnimation } from "hooks/useScrollAnimation";
import { useEffect } from "react";
import Benefits from "./components/Benefits/Benefits";
import FaqSection from "./components/Faq/FaqSection";
import Requirements from "./components/Requirements/Requirements";
import { Steps } from "./components/Steps/Steps";
import { Top } from "./components/Top/Top";
import "./i18n";

const Home = () => {
  const { reveal } = useScrollAnimation();

  useEffect(() => {
    reveal();
  }, [reveal]);
  return (
    <>
      <Navbar />
      <Top />
      <Benefits />
      <Requirements />
      <Steps />
      <FaqSection />
      <ScrollUp />
      <Footer />
    </>
  );
};

export default Home;
